import React from "react";

export default function Heart({
  width = "37",
  height = "32",
  stroke = "#51d88a",
  fill = "#e3fcec"
}) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 37 32"
    >
      <g id="Canvas" fill="none">
        <g id="Heart">
          <g id="Vector">
            <path
              d="M 17.5 30L 4.31032 16.6083C 3.03101 15.8386 1.96487 14.752 1.2116 13.4502C 0.458322 12.1484 0.0425267 10.6739 0.0030933 9.16455C -0.0363401 7.65523 0.301877 6.16042 0.986116 4.8199C 1.67035 3.47937 2.67826 2.33694 3.91558 1.49943C 5.15289 0.661913 6.5792 0.156687 8.0611 0.0309935C 9.54301 -0.0946997 11.0321 0.163246 12.3891 0.78071C 13.7462 1.39817 14.9268 2.35498 15.8206 3.56166C 16.7144 4.76833 17.2922 6.18545 17.5 7.68049C 17.7078 6.18545 18.2856 4.76833 19.1794 3.56166C 20.0732 2.35498 21.2538 1.39817 22.6109 0.78071C 23.9679 0.163246 25.457 -0.0946997 26.9389 0.0309935C 28.4208 0.156687 29.8471 0.661913 31.0844 1.49943C 32.3217 2.33694 33.3296 3.47937 34.0139 4.8199C 34.6981 6.16042 35.0363 7.65523 34.9969 9.16455C 34.9575 10.6739 34.5417 12.1484 33.7884 13.4502C 33.0351 14.752 31.969 15.8386 30.6897 16.6083L 17.5 30Z"
              transform="translate(1 1)"
              fill={fill}
            />
            <path
              d="M 17.5 30L 4.31032 16.6083C 3.03101 15.8386 1.96487 14.752 1.2116 13.4502C 0.458322 12.1484 0.0425267 10.6739 0.0030933 9.16455C -0.0363401 7.65523 0.301877 6.16042 0.986116 4.8199C 1.67035 3.47937 2.67826 2.33694 3.91558 1.49943C 5.15289 0.661913 6.5792 0.156687 8.0611 0.0309935C 9.54301 -0.0946997 11.0321 0.163246 12.3891 0.78071C 13.7462 1.39817 14.9268 2.35498 15.8206 3.56166C 16.7144 4.76833 17.2922 6.18545 17.5 7.68049C 17.7078 6.18545 18.2856 4.76833 19.1794 3.56166C 20.0732 2.35498 21.2538 1.39817 22.6109 0.78071C 23.9679 0.163246 25.457 -0.0946997 26.9389 0.0309935C 28.4208 0.156687 29.8471 0.661913 31.0844 1.49943C 32.3217 2.33694 33.3296 3.47937 34.0139 4.8199C 34.6981 6.16042 35.0363 7.65523 34.9969 9.16455C 34.9575 10.6739 34.5417 12.1484 33.7884 13.4502C 33.0351 14.752 31.969 15.8386 30.6897 16.6083L 30.6897 16.6083L 17.5 30Z"
              strokeLinecap="round"
              transform="translate(1 1)"
              stroke={stroke}
            />
          </g>
        </g>
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/Icons/Heart.js